import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

// import AdminForm from '@/components/modules/admins/Form';
// import AdminIndex from '@/components/modules/admins/Index';
import BadgesIndex from '@/components/modules/badges/Index';
import BadgesForm from '@/components/modules/badges/Form';
import CategoryForm from '@/components/modules/categories/Form';
import CategoryIndex from '@/components/modules/categories/Index';
import Dashboard from '@/components/Dashboard';
import DashboardIndex from '@/components/modules/dashboard/Index';
import DestinationForm from '@/components/modules/destinations/Form';
import DestinationIndex from '@/components/modules/destinations/Index';
import InventoryForm from '@/components/modules/inventory/Form';
import InventoryIndex from '@/components/modules/inventory/Index';
import InventoryView from '@/components/modules/inventory/View';
import Login from '@/components/Login';
import Forgot from '@/components/Forgot';
import Reset from '@/components/Reset';
import MoodForm from '@/components/modules/moods/Form';
import MoodIndex from '@/components/modules/moods/Index';
import NotFound from '@/components/modules/dashboard/404';
import ProductForm from '@/components/modules/products/Form';
import ProductIndex from '@/components/modules/products/Index';
import HighlightsForm from '@/components/modules/highlights/Form';
import TagForm from '@/components/modules/tags/Form';
import TagIndex from '@/components/modules/tags/Index';
import VendorForm from '@/components/modules/vendors/Form';
import VendorIndex from '@/components/modules/vendors/Index';
import MerchantForm from '@/components/modules/merchant/Form';
import MerchantIndex from '@/components/modules/merchant/Index';
import ReviewIndex from '@/components/modules/review/Index';
import ReviewForm from '@/components/modules/review/Form';
import ReviewApproval from '@/components/modules/review/Approval';
import BinIndex from '@/components/modules/operation/bin/Index';
import BinForm from '@/components/modules/operation/bin/Form';
import PaymentMethodsIndex from '@/components/modules/operation/payment/methods/Index';
import PaymentSetupsIndex from '@/components/modules/operation/payment/setups/Index';
import PromoIndex from '@/components/modules/promo/Index';
import PromoBinIndex from '@/components/modules/promo/bin/Index';
import PromoBinForm from '@/components/modules/promo/bin/Form';
import PromoCodeIndex from '@/components/modules/promo/code/Index';
import PromoCodeForm from '@/components/modules/promo/code/Form';
import PromoCodeView from '@/components/modules/promo/code/View';
import PromoConfigIndex from '@/components/modules/promo/config/Index';
import PromoConfigForm from '@/components/modules/promo/config/Form';
import PromoConfigView from '@/components/modules/promo/config/View';
import OrderSummary from '@/components/modules/orders/summary/Index';
import Payment2Merchant from '@/components/modules/orders/payment2Merchant/Index';
import RequestIndex from '@/components/modules/requests/Index';
import SettingsIndex from '@/components/modules/settings/Index';
import KlookIndex from '@/components/modules/klook/Index';
import KlookView from '@/components/modules/klook/View';
import UserIndex from '@/components/modules/user/index';
import UserForm from '@/components/modules/user/form';
import ProfileForm from '@/components/modules/profile/form';
import TicketingRedeem from '@/components/modules/ticketing/redeem';
import TicketingCheckIn from '@/components/modules/ticketing/checkin';

Vue.use(Router);

// Routing logic
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: (to, from, next) => {
        document.body.className = 'login-page';
        next();
      },
      beforeRouteLeave: (to, from, next) => {
        document.body.classList.remove('login-page');
        next();
      },
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: Forgot,
      beforeEnter: (to, from, next) => {
        document.body.className = 'login-page';
        next();
      },
      beforeRouteLeave: (to, from, next) => {
        document.body.classList.remove('login-page');
        next();
      },
    },
    {
      path: '/reset-password',
      name: 'reset',
      component: Reset,
      beforeEnter: (to, from, next) => {
        document.body.className = 'login-page';
        next();
      },
      beforeRouteLeave: (to, from, next) => {
        document.body.classList.remove('login-page');
        next();
      },
    },
    {
      path: '/',
      component: Dashboard,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        document.body.classList.add('skin-blue', 'sidebar-mini');
        next();
      },
      activate() {
        this.$nextTick(() => {
          // => 'DOM loaded and ready'
        });
      },
      children: [
        {
          path: '',
          redirect: '/dashboard',
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: DashboardIndex,
        },

        /*
         * Admins
         */

        // {
        //   path: '/admins',
        //   name: 'admin-index',
        //   component: AdminIndex,
        // },
        // {
        //   path: '/admins/create',
        //   name: 'admin-create',
        //   component: AdminForm,
        //   props: {
        //     isCreate: true,
        //   },
        // },
        // {
        //   path: '/admins/:id/edit',
        //   name: 'admin-edit',
        //   component: AdminForm,
        //   props: {
        //     isCreate: false,
        //   },
        // },
        /*
         * Badges
         */

        {
          path: '/badges',
          name: 'badges-index',
          component: BadgesIndex,
        },
        {
          path: '/badges/create',
          name: 'badges-create',
          component: BadgesForm,
          props: {
            isCreate: true,
          },
        },
        {
          path: '/badges/:id/edit',
          name: 'badges-edit',
          component: BadgesForm,
          props: {
            isCreate: false,
          },
        },
        /*
         * Categories
         */

        {
          path: '/categories',
          name: 'category-index',
          component: CategoryIndex,
        }, {
          path: '/categories/create',
          name: 'category-create',
          component: CategoryForm,
          props: {
            isCreate: true,
          },
        },
        {
          path: '/categories/:id/edit',
          name: 'category-edit',
          component: CategoryForm,
          props: {
            isCreate: false,
          },
        },

        /*
         * Tags
         */

        {
          path: '/tags',
          name: 'tag-index',
          component: TagIndex,
        },
        {
          path: '/tags/create',
          name: 'tag-create',
          component: TagForm,
          props: {
            isCreate: true,
          },
        },
        {
          path: '/tags/:id/edit',
          name: 'tag-edit',
          component: TagForm,
          props: {
            isCreate: false,
          },
        },

        /*
         * Destinations
         */

        {
          path: '/destinations',
          name: 'destination-index',
          component: DestinationIndex,
        },
        {
          path: '/destinations/create',
          name: 'destination-create',
          component: DestinationForm,
          props: {
            isCreate: true,
          },
        },
        {
          path: '/destinations/:id/edit',
          name: 'destination-edit',
          component: DestinationForm,
          props: {
            isCreate: false,
            isEdit: true,
          },
        },
        {
          path: '/destinations/:id/view',
          name: 'destination-view',
          component: DestinationForm,
          props: {
            isCreate: false,
            isEdit: false,
            isView: true,
          },
        },

        /*
         * Moods
         */

        {
          path: '/moods',
          name: 'mood-index',
          component: MoodIndex,
        },
        {
          path: '/moods/create',
          name: 'mood-create',
          component: MoodForm,
          props: {
            isCreate: true,
          },
        },
        {
          path: '/moods/:id/edit',
          name: 'mood-edit',
          component: MoodForm,
          props: {
            isCreate: false,
          },
        },

        /*
         * Inventory
         */
        {
          path: '/inventory',
          name: 'inventory-index',
          component: InventoryIndex,
        },
        {
          path: '/inventory/tickets/:page',
          name: 'inventory-index-page',
          component: InventoryIndex,
        },
        {
          path: '/inventory/create',
          name: 'inventory-create',
          component: InventoryForm,
          props: {
            isCreate: true,
          },
        },
        {
          path: '/inventory/:id/edit',
          name: 'inventory-edit',
          component: InventoryForm,
          props: {
            isCreate: false,
          },
        },
        {
          path: '/inventory/:id',
          name: 'inventory-view',
          component: InventoryView,
        },

        /*
         * Vendors
         */

        {
          path: '/sources',
          name: 'source-index',
          component: VendorIndex,
        },
        {
          path: '/sources/create',
          name: 'source-create',
          component: VendorForm,
          props: {
            isCreate: true,
          },
        },
        {
          path: '/sources/:id/edit',
          name: 'source-edit',
          component: VendorForm,
          props: {
            isCreate: false,
          },
        },

        /*
         * Review
         */
        {
          path: '/review',
          name: 'review-index',
          component: ReviewIndex,
        },
        {
          path: '/review/create',
          name: 'review-create',
          component: ReviewForm,
          props: {
            isCreate: true,
          },
        },
        {
          path: '/review/:id/approval',
          name: 'review-approval',
          component: ReviewApproval,
        },


        /*
         * Merchant
         */

        {
          path: '/merchant',
          name: 'merchant-index',
          component: MerchantIndex,
        },
        {
          path: '/merchant/create',
          name: 'merchant-create',
          component: MerchantForm,
          props: {
            isCreate: true,
          },
        },
        {
          path: '/merchant/:id/edit',
          name: 'merchant-edit',
          component: MerchantForm,
          props: {
            isCreate: false,
          },
        },

        /*
         * Products
         */

        {
          path: '/products',
          name: 'product-index',
          component: ProductIndex,
        },
        {
          path: '/products/page/:page',
          name: 'product-index-page',
          component: ProductIndex,
        },
        {
          path: '/products/create',
          name: 'product-create',
          component: ProductForm,
          props: {
            isCreate: true,
          },
        },
        {
          path: '/products/:id/edit',
          name: 'product-edit',
          component: ProductForm,
          props: {
            isCreate: false,
          },
        },

        /*
        * Klook
        */
        {
          path: '/klook',
          name: 'klook-index',
          component: KlookIndex,
        },
        {
          path: '/klook/activity/:id',
          name: 'klook-view',
          component: KlookView,
        },

        /*
         * Highlights
         */

        {
          path: '/highlights/create',
          name: 'highlights-create',
          component: HighlightsForm,
          props: {
            isCreate: true,
          },
        },
        {
          path: '/highlights/edit',
          name: 'highlights-edit',
          component: HighlightsForm,
          props: {
            isCreate: false,
          },
        },

        /*
         * Payments
         */

        {
          path: '/payment-methods',
          component: PaymentMethodsIndex,
          children: [
            {
              name: 'payment-methods-index',
              path: ':page',
            },
            {
              name: 'payment-methods-edit',
              path: ':id/:page',
            },
          ],
        },
        {
          path: '/payment-setups',
          component: PaymentSetupsIndex,
          children: [
            {
              name: 'payment-setups-index',
              path: ':page',
            },
            {
              name: 'payment-setups-edit',
              path: ':id/:page',
            },
          ],
        },

        /*
         * BIN
         */

        {
          path: '/operation/bin',
          name: 'bin-index',
          component: BinIndex,
        },
        {
          path: '/operation/bin/create',
          name: 'bin-create',
          component: BinForm,
          props: {
            isCreate: true,
          },
        },
        {
          path: '/operation/bin/:id/edit',
          name: 'bin-edit',
          component: BinForm,
          props: {
            isCreate: false,
          },
        },

        /*
         * Promo
         */

        {
          path: '/promo',
          name: 'promo-index',
          component: PromoIndex,
        },
        {
          path: '/promo/bin',
          name: 'promo-bin-index',
          component: PromoBinIndex,
        },
        {
          path: '/promo/bin/create',
          name: 'promo-bin-create',
          component: PromoBinForm,
          props: {
            isCreate: true,
          },
        },
        {
          path: '/promo/bin/:id/edit',
          name: 'promo-bin-edit',
          component: PromoBinForm,
          props: {
            isCreate: false,
          },
        },
        {
          path: '/promo/code',
          name: 'promo-code-index',
          component: PromoCodeIndex,
        },
        {
          path: '/promo/code/create',
          name: 'promo-code-create',
          component: PromoCodeForm,
          props: {
            isCreate: true,
          },
        },
        {
          path: '/promo/code/:id/edit',
          name: 'promo-code-edit',
          component: PromoCodeForm,
          props: {
            isCreate: false,
          },
        },
        {
          path: '/promo/code/:id',
          name: 'promo-code-view',
          component: PromoCodeView,
        },
        {
          path: '/promo/config',
          name: 'promo-config-index',
          component: PromoConfigIndex,
        },
        {
          path: '/promo/config/create',
          name: 'promo-config-create',
          component: PromoConfigForm,
          props: {
            isCreate: true,
          },
        },
        {
          path: '/promo/config/:id/edit',
          name: 'promo-config-edit',
          component: PromoConfigForm,
          props: {
            isCreate: false,
          },
        },
        {
          path: '/promo/config/:id',
          name: 'promo-config-view',
          component: PromoConfigView,
        },

        /*
         * Requests
         */

        {
          path: '/requests',
          name: 'requests-index',
          component: RequestIndex,
        },

        /*
         * Settings
         */

        {
          path: '/settings',
          name: 'settings-index',
          component: SettingsIndex,
        },

        /*
         * Orders
         */

        {
          path: '/orders',
          name: 'orders-summary',
          component: OrderSummary,
        },
        {
          path: '/orders/summary/:page',
          name: 'orders-summary-page',
          component: OrderSummary,
        },
        {
          path: '/order-payment',
          name: 'order-payment',
          component: Payment2Merchant,
        },
        {
          path: '/order-payment/summary/:page',
          name: 'order-payment-page',
          component: Payment2Merchant,
        },
        {
          path: '/user-setup',
          name: 'user-setup-page',
          component: UserIndex,
        },
        {
          path: '/user-setup/crete',
          name: 'user-form-crete',
          component: UserForm,
          props: {
            isCreate: true,
          },
        },
        {
          path: '/user-setup/:id/edit',
          name: 'user-form-edit',
          component: UserForm,
          props: {
            isCreate: false,
          },
        },
        {
          path: '/profile',
          name: 'profile-page',
          component: ProfileForm,
        },
        /*
         * Ticketing
         */
        {
          path: '/ticketing/redeem',
          name: 'ticketing-redeem',
          component: TicketingRedeem,
        },
        {
          path: '/ticketing/check-in',
          name: 'ticketing-check-in',
          component: TicketingCheckIn,

        },

        /*
         * Errors
         */
        {
          path: '*',
          name: '404',
          component: NotFound,
        },

      ],
    },
    {
      path: '*',
      redirect: '/login',
    },
  ],
});

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && (store.state.token === null)) {
    next('/login');
  } else if ((store.state.token !== null) && to.path === '/login') {
    next('/dashboard');
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js